<template>
  <div id="Country">
      <v-container class="pa-0">
        <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn v-if="editIndex === -1" fab absolute right class="mr-3 pf-btn-fab" :href="'#/countries/add'">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn v-else fab absolute left @click="backTolisting" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
      </v-container>  
      <v-container grid-list-md fluid class="pt-0" v-if="editIndex === -1">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card class="mt-1">
      <v-data-table
        :headers="countryHeaders"
        :items="Country"
        :search="search"
        class="pf-data-table" 
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.code }}</td>
          <td align="right">
            <v-btn icon class="ma-0" @click="editItem(props.item)">
              <v-icon size="22" color="grey darken-2">edit</v-icon>
            </v-btn>
            <v-btn icon class="ma-0" @click="deleteItem(props.item)">
              <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      </v-card>
      </v-container>
      <v-form v-else ref="formEdit">
        <v-container>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout wrap class="pb-4 pt-3">
            <v-flex>
              <v-layout wrap>
                <v-flex class="xs12 sm6 full">
                  <v-text-field label="Country Name" v-model.trim="editData.name" :rules="[rules.required]" class="pr-4 pl-4 required" @input="changedData" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex class="xs12 sm6 full">
                  <v-text-field label="Country Code" v-model.trim="editData.code" :rules="[rules.required, rules.onlyTwoLetters]" class="pr-4 pl-4 required" @input="changedData" required></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
            <v-flex xs12 class="button-container pr-0 text-xs-right">
              <div class="d-inline-flex" v-if="selectedData">
                <v-btn class="pf-btn pf-btn-cancel" @click="backTolisting">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="save">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
  </div>
</template>

<script>
/* global session store config  */
import swal from 'sweetalert2';
import { getCollection, update, remove } from '../../helpers/helpers';
import { mapGetters } from 'vuex';

// This lists all the countries and allow to edit them.
export default {
  name: 'ListCountry',
  data: () => ({
    search: '',
    countryHeaders: [
      { text: 'Country Name', value: 'name', align: 'left' },
      { text: 'Country Code', value: 'code', align: 'left' },
      { text: '', sortable: false },
    ],
    selectedData: false,
    editIndex: -1,
    editData: {},
    rules: {
      required: value => !!value.trim() || 'Field is required.',
      onlyTwoLetters: value => (value.trim().length === 2 && /^[a-zA-Z]+$/.test(value.trim())) || 'Country code must have two letters.'
    },
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },  
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Country'])
  },
  watch: {
  },
  created () {
    this.initialize();
  },
  methods: {
    // @vuese
    // Used to fetch the country list if not already exists
    async initialize () {
      if (!this.Country.length) {
        let entity = 'Country';
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setCountry', data);
          }
        }
      }
    },
    // @vuese
    // Used to setup to edit the country
    // @arg The country item to be edited
    editItem (item) {
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.editIndex = this.Country.indexOf(item);
      this.editData = Object.assign({}, item);
    },
    // @vuese
    // Used to delete the country item
    // @arg The country item to be deleted
    deleteItem (item) {

      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Country', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.Country.indexOf(item);
              this.Country.splice(index, 1);
              swal.fire(
                'Deleted!',
                'The Country "' + item.name + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to save the edited country
    async save () {
      if (this.$refs.formEdit.validate() && this.editIndex > -1) {
        this.selectedData = false;
        let { error, data, status } = await update('Country', this.editData, this.editData.id);
        if (error) {
          console.log('error', error);
          this.selectedData = true;
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.Country[this.editIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Country updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    // @vuese
    // Used to go back to the country listing from edit page
    backTolisting () {
      this.editIndex = -1;
      this.selectedData = false;
      window.getApp.$emit('pageSubHeader', '');
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Country/list.vue